module.exports = __webpack_public_path__ + "assets/img/23_21.22039073.jpg";